import React from 'react';
import { reduxForm } from 'redux-form';
//import { Link } from 'react-router-dom';
import FieldRenderComponent from '../FieldRenderComponent';
import fields from './fields';
import { connect } from 'react-redux';
import constants from '../Constants';
import { returnFormattedDate, returnRegisteredOwner, returnFormatedZip } from '../utils/formatReturnedData';

let VehicleForm = (props) => {
    //const { currentVehicle } = props;
    //const { year, make, model, vehicleType } = currentVehicle;
    const shouldRenderQuestion = (currentFormValues, field)=> {

        switch(field.name){
            case 'accidentDate':
            if(currentFormValues){
                return currentFormValues.collisionIndicator === 'N'? false: true;
            }
            default:
            return true;
        }
    };

    let values;
    
    if(props.currentState.form.vehicle){
        values = props.currentState.form.vehicle.values;
    }

    

    const { onNextPage, onPrevPage } = props;
    return (
        <div>
            {fields.map((field, index) => {
                
                return (
                    <div key={index}>
                        {shouldRenderQuestion(values,field)?<FieldRenderComponent  {...field} />: null}
                    </div>
                )
            })}

            <div className="app-form-actions">
            <button 
                className="btn btn-primary app-align-right"
                onClick={onNextPage}>
                {'Next '}
                <i className={constants.icons.next} />
            </button>
            <button
                className="btn btn-primary app-align-left"
                onClick={onPrevPage}>
                <i className={constants.icons.prev} />
                {' Back'}
            </button>
                {/*
            <Link
                className="btn btn-primary"
                to={onNextPage}>
                {'Next '}
                <i className={constants.icons.next} />
            </Link>
             */}
            </div>
        </div>
    );
}

VehicleForm = reduxForm({
    form: 'vehicle',
    enableReinitialize: true
})(VehicleForm);

export default connect(
    (state, props) => {
        console.log(state);
        const { currentVehicle } = props;
        console.log(props);

        const returnObjectData = (key) => {
            return currentVehicle[key] ? currentVehicle[key].code : null;
        }


        const vehicleType = returnObjectData('vehicleType');
        const registeredOwnerName = returnRegisteredOwner(currentVehicle.registeredOwnerName);
        const nameTitle1 = returnObjectData('nameTitle1');
        const nameCode2 = returnObjectData('nameCode2');
        const lesseeLessor = returnObjectData('lesseeLessor');
        const documentType = returnObjectData('documentType');
        const plateType = returnObjectData('plateType');
        const vinChangeIndicator = returnObjectData('vinChangeIndicator');
        const vinCompare = returnObjectData('vinCompare');
        const fromDate = returnFormattedDate(currentVehicle.fromDate);
        const toDate = returnFormattedDate(currentVehicle.toDate);
        const transactionDate = returnFormattedDate(currentVehicle.transactionDate);
        const expirationDate = returnFormattedDate(currentVehicle.expirationDate);
        //const bodilyInjury = getCoverageType(currentVehicle, "BINJ");
        //const propertyDamage = getCoverageType(currentVehicle, "PDMG");
        const city = currentVehicle.addresses?currentVehicle.addresses[0].city:null;
        const stateCode = currentVehicle.addresses[0].stateCode;
        const street1 = currentVehicle.addresses[0].street1;
        const zip = currentVehicle.addresses[0].zip?returnFormatedZip(currentVehicle.addresses[0].zip):null;
        const addressType = currentVehicle.addresses[0].addressType;
        //todo create something custom for coverages

        return ({
            initialValues: {
                ...currentVehicle,
                vehicleType: 'SD',
                registeredOwnerName,
                vinChangeIndicator,
                nameTitle1,
                nameCode2,
                lesseeLessor,
                documentType,
                plateType,
                vinCompare,
                fromDate,
                toDate,
                transactionDate,
                expirationDate,
                //bodilyInjury,
                //propertyDamage,
                city,
                stateCode,
                stateOfRegistration: 'CO',
                addressType,
                street1,
                zip

            } // pull initial values from account reducer
        })
    })(VehicleForm);




// WEBPACK FOOTER //
// ./src/Vehicle/VehicleForm.js